import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VersionCheckService } from '@sla-ng/core';
import { IVersion } from '../../models/version.model';
import { VersionCheckDialogComponent } from './version-check-dialog/version-check-dialog.component';

/**
 *  // In App Component einfügen
 *  const  version = require('../assets/version.json');
 *  public version: { version: string, timestamp: string } = version;
 *
 *  <sla-version-check [version]="version" [blockTimeMinutes]="15" [checkIntervallMillis]="15000"></sla-version-check>
 *
 *  // Task zu gulpfile.js hinzufügen
 *  gulp.task('build:create-version', function (done) {
 *      var pkg = require('./package.json');
 *      var fs = require('fs');
 *      const d = new Date();
 *      fs.writeFile('projects/demo-app/src/assets/version.json', '{ "version": "' + pkg.version + '" , "timestamp": "' + d.toISOString() + '" }', () => {
 *          done();
 *      });
 *      return null;
 *  });
 *
 *  // Prebuild Schritt in package.json unter scripts hinzufügen
 *  "prebuild":"gulp build:create-version",
 *
 */
@Component({
    selector: 'mat-sla-version-check',
    templateUrl: './sla-version-check.component.html',
    styleUrls: [ './sla-version-check.component.scss' ],
})
export class SlaVersionCheckComponent implements OnInit {

    @Input()
    public version: IVersion;

    @Input()
    public blockTimeMinutes: number = 15;

    @Input()
    public checkIntervalMillis: number = 15000;

    private blocked: boolean = false;

    constructor(private myVersionCheckService: VersionCheckService,
                private myMatDialog: MatDialog) {
    }

    public ngOnInit(): void {
        this.myVersionCheckService.observeVersionChange(this.version, this.checkIntervalMillis).subscribe(() => {
            if (!this.blocked) {
                this.blocked = true;
                this.myMatDialog.open(VersionCheckDialogComponent, {
                    data: this.blockTimeMinutes,
                    autoFocus: false,
                })
                    .afterClosed()
                    .subscribe((action: 'ignore' | 'reload') => {
                        if (action === 'ignore') {
                            setTimeout(() => {
                                this.blocked = false;
                            }, +(this.blockTimeMinutes * 60 * 1000).toFixed(0));
                        } else if (action === 'reload') {
                            this.myVersionCheckService.reloadLocation();
                        } else {
                            this.blocked = false;
                        }
                    });
            }
        });
    }

}
